import { useQuery } from '@apollo/client';

import { USER_TARGETS } from '../graphql/query/userTargetsQuery.graphql';

export const useUserTargetsQuery = (eventId: string) => {
  return useQuery(USER_TARGETS, {
    variables: { eventId },
    fetchPolicy: 'cache-and-network',
  });
};
